const normalizePercent = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const normalized = String(value).replace(',', '.').trim();
  const parsed = Number(normalized);

  return Number.isFinite(parsed) ? parsed : null;
};

const toApiPercent = (value) => {
  const parsed = normalizePercent(value);
  if (parsed === null) {
    return value ?? '';
  }

  return parsed / 100;
};

const fromApiPercent = (value) => {
  const parsed = normalizePercent(value);
  if (parsed === null) {
    return value ?? '';
  }

  return parsed * 100;
};

export {
  fromApiPercent,
  toApiPercent,
};
